<nav
	*ngIf="isUserLoggedIn$ | async"
	[class.expanded]="(isNavigationExpanded$ | async )"
>
	<div
		*ngIf="isDashboardEnabled$ | async"
		[class.active]="(activeNavigationItem$ | async) === 'home'"
		class="navigation-item home"
		routerLink="/"
		(click)="closeMenu()"
	>
		<div class="icon-wrapper">
			<svg icon type="home"></svg>
		</div>
		<span>Home</span>
	</div>

	<div class="divider" *ngIf="isDashboardEnabled$ | async"></div>

	<div
		*ngIf="!openedWithSSO && (isARGUSEnabled$ | async)"
		[class.active]="(activeNavigationItem$ | async) === 'argus'"
		class="navigation-item argus"
		routerLink="/argus"
		(click)="closeMenu()"
	>
		<div class="icon-wrapper">
			<svg icon type="argus-logo"></svg>
		</div>
		<span>ARGUS</span>
	</div>


	<div
		*ngIf="isXenaEnabled$ | async"
		[class.active]="(activeNavigationItem$ | async) === 'xena'"
		class="navigation-item xena"
		routerLink="/xena"
		(click)="closeMenu()"
	>
		<div class="icon-wrapper">
			<svg icon type="xena-logo"></svg>
		</div>
		<span>XENA</span>
	</div>

	<div
		*ngIf="isNeoEnabled$ | async"
		[class.active]="(activeNavigationItem$ | async) === 'neo'"
		class="navigation-item neo"
		(click)="openNEO(); closeMenu(false)"
	>
		<div class="icon-wrapper">
			<svg icon type="neo-logo"></svg>
		</div>
		<span>NEO</span>
	</div>

	<div class="divider"></div>

	<div class="navigation-menu addons active">
		<ul class="expanded">
			<li *ngIf="(isSmartBookingEnabled$ | async)">
				<a (click)="openSmaboTransactions()" class="navigation-item">
					<div class="icon-wrapper">
						<svg icon type="smartbooking-logo"></svg>
					</div>
					<span>Smart Booking</span>
				</a>
			</li>

			<li *ngIf="(isBedsAndMoreEnabled$ | async)">
				<a (click)="openBedsAndMore()" class="navigation-item">
					<div class="icon-wrapper">
						<svg icon type="bedsandmore"></svg>
					</div>
					<span>Beds and More</span>
				</a>
			</li>
		</ul>
	</div>

	<div class="divider"></div>

	<div
		*ngIf="(showAdminForGTS$ | async) && ((isXenaEnabled$ | async) || (isURANIAAdminEnabled$ | async) || (isNeoEnabled$ | async))"
		[class.active]="(activeNavigationItem$ | async) === 'admin'"
		class="navigation-item administration"
		routerLink="/admin"
		(click)="closeMenu()"
	>
		<div class="icon-wrapper">
			<svg icon type="setting"></svg>
		</div>
		<span i18n="@@settings">Administration</span>
	</div>

	<div class="divider"></div>

	<!-- open-close-button -->
	<div class="open-close-button-wrapper">
		<div class="open-close-button" (click)="sidebarTrigger()">
			<svg icon *ngIf="( isNavigationExpanded$ | async ) === false" type="arrow-right"></svg>
			<svg icon *ngIf="( isNavigationExpanded$ | async ) === true" type="arrow-left"></svg>
		</div>
	</div>

</nav>

<div class="gosuite-logo-wrapper">
	<div class="icon-wrapper">
		<svg icon type="gosuite-logo" viewBox="0 0 641.5 158.5"></svg>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/components/plat-sidebar/plat-sidebar/plat-sidebar.component.html